<template>
    <div id="main">
        <HeaderNav :isMobile="isMobile" :cdnPrefix="cdnPrefix"></HeaderNav>

        <!-- 背景视频 -->
        <div v-if="!isMobile" class="video-index-bg">
            <div class="video-mask"></div>
            <video class="video-index" loop muted currentTime="0">
                <source src="@assets/video/p20n-cn-01.mp4" type="video/mp4" />
            </video>
        </div>

        <Index :isMobile="isMobile" :cdnPrefix="cdnPrefix"></Index>

        <Video :isMobile="isMobile" :cdnPrefix="cdnPrefix"></Video>

        <Generals :isMobile="isMobile" :cdnPrefix="cdnPrefix"></Generals>

        <StrategicMap :isMobile="isMobile" :cdnPrefix="cdnPrefix"></StrategicMap>

        <Description :isMobile="isMobile" :cdnPrefix="cdnPrefix"></Description>

        <Footer :isMobile="isMobile" :cdnPrefix="cdnPrefix"></Footer>

    </div>
</template>

<script>
import HeaderNav from "./HeaderNav.vue";
import Index from "./Index.vue";
import Video from "./Video.vue";
import Generals from "./Generals.vue";
import StrategicMap from "./StrategicMap.vue";
import Description from "./Description.vue";
import Footer from "./Footer.vue";

export default {
    components: {
        HeaderNav,
        Index,
        Video,
        Generals,
        StrategicMap,
        Description,
        Footer
    },
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        cdnPrefix: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            scrollIndex: 0,
            scrolling: false,
            beforeScrollTop: 0
        };
    },
    watch: {},
    mounted() {
        // 播放背景视频
        if (document.body.offsetWidth > 768) {
            document.getElementById("main").scrollTo(0, 0);
            setTimeout(function() {
                if (screen.availWidth < 980) {
                    return false;
                }
                let elem = document.getElementsByClassName("video-index")[0];
                elem.play();
            }, 200);
        }
        document.querySelector("#main").onscroll = this.handleOnMainScroll;
        document.onwheel = this.handleOnWheel;
    },
    methods: {
        handleOnMainScroll(e) {
            // console.log(e)
            // console.log(e.target.scrollTop)
            // console.log(document.body.offsetWidth, document.body.offsetHeight)
            // document.querySelector('#main').scrollTo(0, document.body.offsetHeight * this.scrollIndex)
            // console.log(e.target.scrollTop, e.target.offsetHeight)
            // console.log(parseInt(e.target.scrollTop / e.target.offsetHeight));
            // this.scrollIndex = parseInt(e.target.scrollTop / e.target.offsetHeight);
        },
        // 鼠标滑轮滚动
        handleOnWheel(event) {
            if (this.scrolling) {
                return;
            }
            // 向上
            if (event.deltaY < 0) {
                if (this.scrollIndex > 0) {
                    this.scrollIndex--;
                    this.handleControlScroll();
                }
            }
            // 向下
            else {
                if (this.scrollIndex < 4) {
                    this.scrollIndex++;
                    this.handleControlScroll();
                }
            }
        },
        // 控制页面滚动
        handleControlScroll() {
            return;
            this.scrolling = true;
            setTimeout(() => {
                document.querySelector("#main").scrollTo({
                    top: document.body.offsetHeight * this.scrollIndex,
                    behavior: "smooth"
                });
                this.scrolling = false;
            }, 200);
        }
    }
};
</script>

<style lang="scss">
@keyframes animate_scan_weixin {
    0% {
        top: 25px;
    }
    50% {
        top: 155px;
    }
    100% {
        top: 25px;
    }
}
#main {
    width: 100vw;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    .video-index-bg {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -999;
        background: rgba(155, 155, 155, 0.2);
        .video-mask {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 10;
            background: rgba(0, 0, 0, 0.5);
        }
        .video-index {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
        }
    }
    .weixin-gzh {
        z-index: 1000;
        background: url("~@assets/imgs/weixin-bg.png") center center
            no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        position: fixed;
        right: 20px;
        top: 40%;
        padding: 20px;
        color: #fff;
        justify-content: center;
        align-content: center;
        letter-spacing: 2px;
        .line-scan {
            width: 130px;
            height: 2px;
            background: #0f0;
            box-shadow: 0 0 6px #04ffe8, 0 0 7px #04ffe8, 0 0 8px #04ffe8,
                0 0 9px #04ffe8;
            position: absolute;
            top: 25px;
            left: 50%;
            margin-left: -65px;
            animation: "animate_scan_weixin" 5s linear infinite;
        }
        p {
            margin: 5px 0;
        }
        .text {
            padding: 5px;
            background: rgba(0, 0, 0, 0.3);
            margin: 5px 0;
            border-radius: 10px;
        }
    }
}
// 移动端
@media screen and (max-width: 768px) {
    #main {
        padding: 40px 0;
        background: url("~@assets/imgs/bgphone-p20n.png") center bottom
            no-repeat;
        background-size: 100% 100%;
        .video-index-bg,
        .weixin-gzh {
            display: none;
        }
        .new-box {
            position: fixed;
            bottom: 0;
            z-index: 1000;
            width: 100%;
            height: 45px;
            display: flex;
            justify-content: space-around;
            background: url("~@assets/imgs/bgphone-new-fb.png") center top
                no-repeat;
            background-size: 100% auto;
            .new-btn {
                line-height: 45px;
                cursor: pointer;
                color: #fff;
                font-weight: bold;
                font-size: 18px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue